'use client';

import Rating from '@/features/primitives/Rating';
import { Badge } from 'react-bootstrap';
import { readMessage } from '../reviewUtils';

export default function CustomersSayCard({
  customersSayCopy,
  marketplaceDate,
  messages,
  rating,
}) {
  return (
    <article className="product-reviews__insight product-reviews__insight--marketplace product-detail-panel__summary-card">
      <div className="product-reviews__marketplace-head">
        <strong className="product-reviews__marketplace-title">
          {readMessage(
            messages,
            'reviewsList.customersSay.title',
            'Amazon Customers Say',
          )}
          :
        </strong>
        <Badge
          bg="warning"
          text="light"
          pill
          className="product-reviews__marketplace-badge"
          aria-label={`${readMessage(messages, 'reviewsList.customersSay.title', 'Amazon Customers Say')} (${readMessage(messages, 'reviewsList.customersSay.sourceBadge', 'Amazon')})`}
        >
          {readMessage(
            messages,
            'reviewsList.customersSay.sourceBadge',
            'Amazon',
          )}
        </Badge>
      </div>
      {Number(rating) ? (
        <div className="product-reviews__insight-rating">
          <Rating value={rating} numReviews={1} showText={false} />
          <span className="insight-rating-text">
            {Number(rating).toFixed(1)} / 5
          </span>
        </div>
      ) : null}
      {marketplaceDate ? (
        <p className="product-reviews__marketplace-date">{marketplaceDate}</p>
      ) : null}
      <p className="product-reviews__insight-copy">{customersSayCopy}</p>
    </article>
  );
}
